import { RpcService } from '@holmescorp/rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/reports/@@group.rpc`,
    services: {
        conversations: {
            parameters: [
                { name: 'session_id', type: 'integer', optional: false },
                { name: 'author_id', type: 'string', optional: false },
                { name: 'select', type: 'object', optional: true }
            ]
        },
        update_conversations: {
            parameters: [
                { name: 'session_id', type: 'integer', optional: false },
                { name: 'data', type: 'object', optional: false },
                { name: 'select', type: 'object', optional: true }
            ]
        }
    }
});
export const singleSvc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/reports/@@reports.rpc`,
    services: {
        reportsrpc: {
            cacheable: false,
            cacheLifetime: 24,
            parameters: [
                { name: 'method', type: 'string', optional: false },
                { name: 'sessionid', type: 'integer', optional: false },
                { name: 'site', type: 'string', optional: true },
                { name: 'data', type: 'object', optional: true },
                { name: 'author_id', type: 'string', optional: true },
                { name: 'select', type: 'Select', optional: true }
            ]
        }
    }
});
export default svc;
